<template>
    <div>
        <ul class="ztree" v-if="orgData">
            <a-input v-if="orgData.children" ref="searchInput" autofocus :placeholder="$t('global.inputFliterTip')" v-model="searchInput" style="margin-bottom:8px"></a-input>
            <z-org-tree-item
                :treeData="orgData"
                 @addNode="onAddNode"
                 @deleteNode="onDeleteNode"
                 @selectNode="onSelectNode">
            </z-org-tree-item>
        </ul>
        <div class="loading" v-else>
          <a-spin></a-spin>
        </div>
    </div>
</template>

<script>
    import ZOrgTreeItem from './OrgTreeItem.vue'
    import config from '@/config'
    import lodash from 'lodash'

    export default {
        name: "ZOrgTree",
        props: ["option"],
        components: {
            ZOrgTreeItem
        },
        data () {
            return {
                systemName: '',
                orgData:'',
                searchInput: '',
                tempObj: null,
                selectedId: null
            }
        },
        watch: {
            searchInput () {
                this.filterOrg()
            }
        },
        created() {
            this.initOrgTree()
        },
        mounted () {
          // this.time && clearInterval(this.time)
          // console.log('mounted')
        },
        methods: {
            getFilterOrg() {
                if (this.searchInput.length > 0){
                    this.orgData = JSON.parse(this.tempObj)
                    this.filterNode(this.orgData)
                    this.setSelectNode(this.orgData,this.selectedId)
                }else{
                    this.orgData = JSON.parse(this.tempObj)
                    this.setSelectNode(this.orgData,this.selectedId)
                }
            },
            filterNode(data){
                let filtered = true;
                if(data.children){
                    for(var i = 0 ; i < data.children.length ; i++){
                        if(data.children[i].children && data.children[i].children.length > 0){
                            if(!this.filterNode(data.children[i]) && data.children[i].name.indexOf(this.searchInput) == -1){
                                data.children.splice(i,1)
                                i --;
                            }
                        }else {
                            if(data.children[i].name.indexOf(this.searchInput) == -1) {
                                data.children.splice(i,1)
                                i --;
                            }
                        }
                    }
                    if(data.children.length == 0){
                        filtered = false;
                    }

                    for(var j = 0 ; j < data.children.length ; j++){
                        if(j == data.children.length - 1){
                            data.children[j].isLastNode = true
                        }else{
                            data.children[j].isLastNode = false
                        }
                    }
                }
                return filtered;
            },
            initOrgTree(data,selectNodeId) {
                if(data){
                    // console.log(data)
                    this.orgData = data
                    this.tempObj = JSON.stringify(this.orgData)
                    this.setTree(selectNodeId)
                    this.filterOrg = lodash.debounce(this.getFilterOrg, 400)
                }else{
                  console.log('start')
                    this.$http.get(config.api.org_tree_all_url).then((response) => {
                        console.log(response)
                        // let t = 0
                        // this.time = setInterval(() => {
                        //   console.log(t += 0.5)
                        // }, 500)
                        this.orgData = response.result
                        this.tempObj = JSON.stringify(this.orgData)
                        this.setTree(selectNodeId)
                        this.filterOrg = lodash.debounce(this.getFilterOrg, 400)
                    }).catch((err) => {
                        console.log(err)
                    })
                }
            },
            setTree(selectNodeId){
                this.selectedId = selectNodeId ? selectNodeId :this.orgData.id
                let selectedNode = this.getNodeById(this.orgData,this.selectedId)
                // console.log(selectedNode)
                this.onSelectNode(selectedNode)
            },

            getNodeById(data,nodeId){
                if(data.id == nodeId){
                    return data
                }
                if(data.children != null){
                    for(var i = 0 ; i < data.children.length ; i ++){
                        let node = this.getNodeById(data.children[i],nodeId);
                        if(node){
                            return node;
                        }
                    }
                }
                return null;
            },

            getSelectNodeId(node){
                let _this = this
                if(node.isSelected == true){
                    return node.id;
                }
                if(node.children != null){
                    for(var i = 0 ; i < node.children.length ; i ++){
                        let nodeId =  _this.getSelectNodeId(node.children[i]);
                        if(nodeId){
                            return nodeId;
                        }
                    }
                }
                return null;
            },

            setSelectNode(node,selectNodeId){
                if(node.id === selectNodeId){
                    node.isSelected = true;
                }else{
                    node.isSelected = false;
                }

                //TO DO 此处值改变后页面未重新渲染，暂未找到解决办法
                var temp = node.name;
                node.name = '';
                node.name = temp;

                var that = this
                if(node.children != null && node.children.length > 0){
                    node.children.map(function(item){
                        that.setSelectNode(item,selectNodeId);
                    })
                }
            },
            onSelectNode(node){
                this.setSelectNode(this.orgData,node.id);
                // console.log(this.orgData)
                // console.log(node)
                this.$emit("orgSelect",node)
            },
            onAddNode(node){
                this.$emit("addNode",node)
            },
            onDeleteNode(node){
                this.$emit("deleteNode",node)
            }
        }
    }
</script>
<style lang="less" scoped>
.loading {
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
